import { Box, Checkbox, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { FiClock } from "react-icons/fi";

const GreenCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    "&$checked": {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);

function CheckBoxWithLabel({ checked, handleChange, text }) {
  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center" className={classes.root}>
      <GreenCheckbox
        checked={checked}
        onChange={handleChange}
        inputProps={{ "aria-label": "primary checkbox" }}
      />
      <Typography variant="body1">
        <p className="text-left text-sm md:text-base">{text}</p>
      </Typography>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "40%",
  },
  soon: {
    margin: "9px 9px 9px 12px",
    padding: "3px 3px 0px 3px",
    color: "#000000",
    background: theme.palette.primary.main,
    borderRadius: "4px",
  },
}));
export default CheckBoxWithLabel;
